import getErrorKey from '../../components/address/getErrorKey';

const errorPrefixPlural = 'errors.formFields.minLength';

const minLength = (min, fieldName) => (value) => {
  if (!value) return; // This validator doesn't enforce 'required' constraint, only min length IF value has been provided.
  
  const errorKey = getErrorKey(fieldName, errorPrefixPlural);
  
  return value.trim().length < min ? [errorKey, min] : undefined;
};

export default minLength;
